<template>
  <PopModal ref="modal" :title="goods && goods.name?$t('有关此产品的任何查询'):$t('给商家留言')">
    <van-form @submit="onClickSend">
      <div class="modal-body gry-bg px-3 pt-3">
        <div v-if="goods && goods.name" class="form-group">
          <input
            :placeholder="$t('产品名称')"
            :value="goods.name"
            class="form-control mb-3"
            disabled
            name="title"
            required=""
            type="text"
          />
        </div>
        <el-form
            :model="sendMsgForm"
            ref="sendMsgFormRef"
            label-width="80px"
            label-position="left"
        >
          <el-form-item :label="$t('消息类型')" prop="type">
            <zselect
                v-model="sendMsgForm.type"
                :dict-list="[
        { code: 'text', label: $t('文本') },
        { code: 'url', label: $t('链接') },
        { code: 'image', label: $t('图片') }
    ]"
                size="small"
                default-first
            />
          </el-form-item>

          <!-- 文本内容 -->
          <el-form-item
              :label="$t('消息内容')"
              prop="content"
              v-if="sendMsgForm.type === 'text'"
          >
            <el-input
                type="textarea"
                v-model="sendMsgForm.content"
                :rows="6"
                class="msg-input"
            />
          </el-form-item>

          <!-- 链接地址 -->
          <el-form-item
              :label="$t('链接')"
              prop="content"
              v-if="sendMsgForm.type === 'url'"
          >
            <el-input
                v-model="sendMsgForm.content"
                placeholder="https://example.com"
                class="msg-input"
            />
          </el-form-item>


          <!-- 图片上传 -->
          <el-form-item
              :label="$t('图片')"
              prop="content"
              v-if="sendMsgForm.type === 'image'"
          >
            <zfield
                v-model="sendMsgForm.content"
                required
                type="image"
                width="200px"
            ></zfield>
          </el-form-item>
        </el-form>

      </div>
      <div class="modal-footer">
        <button
          class="btn btn-outline-primary fw-600"
          data-dismiss="modal"
          type="button"
          @click="onClickCancel"
        >
          {{ $t("取消") }}
        </button>
        <van-button
          :loading="loading"
          :loading-text="$t('submitting')"
          class="btn btn-primary fw-600"
          native-type="submit"
          type="primary"
        >
          {{ $t("submit") }}
        </van-button>
      </div>
    </van-form>
  </PopModal>
</template>
<script>
import PopModal from "@/components/PopModal.vue";
import Zupload from "@/parent-ui/src/main/ui-element/zupload.vue";

export default {
  data() {
    return {
      loading: false,
      goods: {},
      shopUserId: null,
      sendMsgForm: {
        type:'text',
        content: '',
      },
    };
  },
  components: {
    Zupload,
    PopModal
  },
  methods: {
    show(goods, shopUserId) {
      this.goods = goods;
      this.shopUserId = shopUserId;
      this.$refs.modal.show();
    },
    onClickCancel() {
      this.$refs.modal.hide();
    },
    onClickSend() {
      this.loading = true;
      this.$post("/user/chatGroupRecord/save", {
        type: this.sendMsgForm.type,
        content: this.sendMsgForm.content,
        businessDataJson: JSON.stringify({ goodsId: this.goods && this.goods.id }),
        initGroupOtherUserId: this.shopUserId,
      })
        .then(() => {
          this.sendMsgForm = {
            content: '',
          };
          this.$refs.modal.hide();
          this.$toast.success(this.$t("Commit_Success"));
          this.jump('/user/conversations')
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
